import { apiClient } from "../../../lib/apiClient"
import type { ApiResponse } from "../../../types/apiResponse";
import type { ChartAccountData } from "../types";

export const fetchChartAccounts = async () => {
  return apiClient<ApiResponse<ChartAccountData[]>>('/v1/catalogs/chart_account', {
    method: "GET"
  });
}
